import React, { Component, PropTypes } from 'react';

export default class EmailGroupCheckbox extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  onChange() {
    this.props.onChange();
    this.props.updateSettings();
    this.props.unwatchAllCategories();
  }

  render() {
    const { id, group, checked } = this.props;

    return (<div className="row">
      <div className="small-16 medium-8 column">
        <div className="radio">
          <input
            name="email-group"
            type="radio"
            id={`email-group-${id}`}
            checked={checked}
            onChange={this.onChange}
          />
          <label htmlFor={`email-group-${id}`} className="form-label">{group}</label>
        </div>
      </div>
    </div>);
  }
}

EmailGroupCheckbox.propTypes = {
  onChange: PropTypes.func.isRequired,
  checked: PropTypes.bool,
  group: PropTypes.string,
  id: PropTypes.string,
  updateSettings: PropTypes.func.isRequired,
  unwatchAllCategories: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./account/components/email_group_checkbox.jsx